import { render, staticRenderFns } from "./Seismicity.vue?vue&type=template&id=16bb9dc8&scoped=true&"
import script from "./Seismicity.vue?vue&type=script&lang=js&"
export * from "./Seismicity.vue?vue&type=script&lang=js&"
import style0 from "./Seismicity.vue?vue&type=style&index=0&id=16bb9dc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bb9dc8",
  null
  
)

export default component.exports